import { AppstoreOutlined, MailOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import {
  SHIPPING_FEE_BY_ADDRESS_ROUTE,
  SHIPPING_FEE_BY_ORDER_AMOUNT_ROUTE,
  SHIPPING_FEE_DEFAULT_ROUTE,
} from "shared/constants/routes";

interface IShippingFeeMenuProps {
  activeKey: string;
}

export function ShippingFeeMenu(props: IShippingFeeMenuProps) {
  const { activeKey } = props;
  return (
    <Menu selectedKeys={[activeKey]} mode="horizontal" className="mb-4">
      <Menu.Item key="1" icon={<MailOutlined />}>
        <Link to={SHIPPING_FEE_DEFAULT_ROUTE}>Phí ship mặc định</Link>
      </Menu.Item>
      <Menu.Item key="2" icon={<AppstoreOutlined />}>
        <Link to={SHIPPING_FEE_BY_ADDRESS_ROUTE}>Phí ship theo quận huyện</Link>
      </Menu.Item>
      <Menu.Item key="3" icon={<AppstoreOutlined />}>
        <Link to={SHIPPING_FEE_BY_ORDER_AMOUNT_ROUTE}>
          Phí ship theo tiền hàng
        </Link>
      </Menu.Item>
    </Menu>
  );
}
